import React, { FC, useEffect, useRef } from 'react';
import { Link as TLink } from '~/lib/data-contract/auto-generated/api-model';
import { Link } from '~/shared/components/Link/Link';
import { useIsMobile } from '~/shared/hooks/useIsMobile/useIsMobile';
import { theme } from '~/theme';
import {
    BreadcrumbsContainer,
    BreadcrumbsItem,
    BreadcrumbsList,
    StyledChevron,
} from './Breadcrumb.styled';

export interface IBreadcrumbProps {
    items: TLink[];
    shouldFloat?: boolean;
    color?: typeof theme.colors.white | typeof theme.colors.black;
}

const Breadcrumbs: FC<IBreadcrumbProps> = ({
    items,
    shouldFloat = false,
    color = theme.colors.black,
}) => {
    const breadcrumbRef = useRef<null | HTMLUListElement>(null);
    const isMobile = useIsMobile();
    useEffect(() => {
        if (breadcrumbRef.current && isMobile) {
            breadcrumbRef.current.scrollTo(breadcrumbRef.current.getBoundingClientRect().width, 0);
        }
    }, [breadcrumbRef.current, isMobile]);

    return (
        <BreadcrumbsContainer isFloating={shouldFloat}>
            <BreadcrumbsList ref={breadcrumbRef}>
                {items.map((link, i) => (
                    <BreadcrumbsItem color={color} key={`${link.title ?? link.text}-${i}`}>
                        {i === items.length - 1 ? (
                            link.text
                        ) : (
                            <>
                                <Link {...link} href={link.url} color={color} tabIndex={-1}>
                                    {link.text}
                                </Link>
                                <StyledChevron />
                            </>
                        )}
                    </BreadcrumbsItem>
                ))}
            </BreadcrumbsList>
        </BreadcrumbsContainer>
    );
};

export default Breadcrumbs;
